var React = require('react');

function VolumeMute (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.569 20.73a.915.915 0 0 1-.533.263L3.92 21a.919.919 0 0 1-.65-1.569L18.431 4.27a.915.915 0 0 1 .533-.262L19.08 4l.117.007a.919.919 0 0 1 .532 1.561L17.34 7.96v-.001l-.248.247L4.569 20.731zm8.158-6.745v5.63c0 .81-.85.102-.93.033l-.006-.005-2.654-2.068 3.59-3.59zM20 12.488c0 2.37-.838 4.744-2.512 6.555a.638.638 0 0 1-.466.207.64.64 0 0 1-.467-.207.752.752 0 0 1 0-1.002c1.422-1.534 2.128-3.54 2.13-5.553a8.29 8.29 0 0 0-.83-3.63l.993-.992A9.785 9.785 0 0 1 20 12.488zm-2.91.007a6.143 6.143 0 0 1-1.731 4.299.678.678 0 0 1-.975 0 .723.723 0 0 1 0-1.003 4.712 4.712 0 0 0 1.329-3.296 4.802 4.802 0 0 0-.184-1.31l1.084-1.083c.319.763.479 1.578.478 2.393zm-4.37-7.294l.007.1V8.56l-7.112 7.112L4 15.673V9.366h2.695l5.208-4.08s.735-.582.817-.085z","fill":"#4A4A4A"}));
}

VolumeMute.defaultProps = {"width":"24","height":"24"};

module.exports = VolumeMute;

VolumeMute.default = VolumeMute;
